import * as React from 'react'

import { CustomerCreditCheckState } from 'store/creditCheck'
import { Button, CheckBox, Text, TextInput } from '../_atoms'

import 'react-datepicker/dist/react-datepicker.css'

import DatePickerWrapper from 'components/_molecules/DatePickerWrapper'
import styled from 'style/styled-components'

const Legalese = styled.textarea`
  width: 100%;
  height: 100px;
  background-color: #eee;
  padding: 10px;
`

class CreditCheckForm extends React.Component<CreditCheckFormProps> {
  public getLegalText(): string {
    return (
      'I hereby authorize and instruct IGS SOLAR to obtain and review my credit agency score. ' +
      'My credit score will be obtained from a credit reporting agency chosen by IGS SOLAR. ' +
      'I understand and agree that IGS SOLAR intends to use the credit score for the purpose of evaluating ' +
      'my financial readiness to enter in to an agreement for a residential solar energy generating system.'
    )
  }

  public render(): JSX.Element {
    const { fields, valid } = this.props.creditCheckForm

    return (
      <form>
        <div className="form-section active">
          <h3 className="form-section-header">Personal Information</h3>
          <CheckBox field={fields.legalNameCorrectlyRepresented} handleChange={this.props.handleChangeToName} />
          <div className="row">
            <TextInput
              id="firstName"
              className="col-12 col-md-4"
              field={fields.firstName}
              handleChange={this.props.handleChange}
              disabled={fields.legalNameCorrectlyRepresented.value}
            />
            <TextInput
              id="middleInitial"
              className="col-12 col-md-4"
              field={fields.middleInitial}
              handleChange={this.props.handleChange}
              disabled={fields.legalNameCorrectlyRepresented.value}
            />
            <TextInput
              id="lastName"
              className="col-12 col-md-4"
              field={fields.lastName}
              handleChange={this.props.handleChange}
              disabled={fields.legalNameCorrectlyRepresented.value}
            />
          </div>
          <div className="row">
            <DatePickerWrapper field={fields.birthDate} id="datePickerWrapper" className="col-12 col-md-4 fs-block" handleChange={this.props.handleChange} />
            <TextInput id="phoneNumber" className="col-12 col-md-4 fs-block" field={fields.phone} handleChange={this.props.handleChange} />
            <TextInput id="ssn" className="col-12 col-md-4 fs-block" field={fields.ssn} handleChange={this.props.handleChange} />
          </div>
          <div className="row">
            <span>&nbsp;</span>
          </div>
          <h3 className="form-section-header">Address</h3>
          <div className="row">
            <TextInput id="addressLine1" className="col-12 col-md-8" field={fields.addressLine1} handleChange={this.props.handleChange} />
            <TextInput id="addressLine2" className="col-12 col-md-4" field={fields.addressLine2} handleChange={this.props.handleChange} />
          </div>
          <div className="row">
            <TextInput id="city" className="col-12 col-md-4" field={fields.city} handleChange={this.props.handleChange} />
            <TextInput id="state" className="col-12 col-md-4" field={fields.state} handleChange={this.props.handleChange} />
            <TextInput id="zipCode" className="col-12 col-md-4" field={fields.zip} handleChange={this.props.handleChange} />
          </div>
          <div className="row">
            <div className="col-12 col-md-12 margin-top">
              <Legalese id="legalText" disabled={true} value={this.getLegalText()} />
            </div>
          </div>
          <CheckBox id="legalCheckbox" field={fields.consent} handleChange={this.props.handleChange} />
          <div className="row justify-content-between">
            <div className="col-12 col-md-4 order-last">
              <Button
                id="submitBtn"
                type="submit"
                disabled={!valid}
                className="btn btn-primary btn-lg btn-block"
                onClick={(e: React.FormEvent<HTMLButtonElement>): void => this.props.handleSubmit(e)}
              >
                <Text>Submit</Text>
              </Button>
            </div>
            <div className="col-12 col-md-4 order-first">
              <Button
                id="resetBtn"
                type="reset"
                className="btn btn-secondary btn-lg btn-block"
                onClick={(e: React.FormEvent<HTMLButtonElement>): void => this.props.handleClearForm(e)}
              >
                <Text>Clear</Text>
              </Button>
            </div>
          </div>
        </div>
      </form>
    )
  }
}
/* tslint:disable no-any */
export interface CreditCheckFormProps {
  creditCheckForm: CustomerCreditCheckState
  handleChange: any
  handleChangeToName: any
  handleClearForm: any
  handleSubmit: any
}
/* tslint:enable no-any */

export default CreditCheckForm



// WEBPACK FOOTER //
// ./src/components/creditCheck/form.tsx